/* eslint-disable */
import {
  assertBoolean,
  attachSingleReferenceComponent,
  attributeSwitchComponent,
  memoEval,
  multilingualTextValueComponent,
  referenceComponent,
  violationsComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachAdminComponent } from '../admin-implementation.js'
import { PresetCategory } from '../admin-model/index.js'

export const presetComponents = [
  attachSingleReferenceComponent(
    attachAdminComponent.withComponent(referenceComponent, 'Preset.$category', true).withEntity('Preset'),
    PresetCategory,
    'categoryId'
  ),

  attachAdminComponent
    .withComponent(multilingualTextValueComponent, 'name', true)
    .withEntity('Preset')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.name],
        name => ({
          value: name,
        })
      ),
      state => {
        return { name: state.value }
      }
    ),

  attachAdminComponent
    .withComponent(multilingualTextValueComponent, 'description', true)
    .withEntity('Preset')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.description],
        description => ({
          value: description,
        })
      ),
      state => {
        return { description: state.value }
      }
    ),

  attachAdminComponent
    .withComponent(attributeSwitchComponent, 'visible', true)
    .withEntity('Preset')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.visible],
        visible => ({
          value: visible,
        })
      ),
      state => {
        assertBoolean(state.value)
        return { visible: state.value }
      }
    ),

  attachAdminComponent
    .withComponent(violationsComponent, 'default', true)
    .withEntity('Preset')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$violations],
        $violations => ({
          violations: $violations,
        })
      )
    ),
]
